/* eslint-disable-next-line padded-blocks */
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import html2pdf from "html2pdf.js";
import ReactDOMServer from "react-dom/server";
// css
import "./Table.modules.css";
// primeReact
import { Button } from "primereact/button";
import { Skeleton } from "primereact/skeleton";
import { BreadCrumb } from "primereact/breadcrumb";
//components
import Panel from "../../../components/panel/panel";
import ModelReport from "../../../components/report/ModelReport";
//pages
import FiltersSales from "./FiltersSales";
import TableSalesReport from "./TableSalesReport";
//assets
import Excel from "../../../assets/excel";
//utils
import { formatDate } from "../../../utils/formatDate";
import { useAppContext } from "../../../context/AppContext";
import { formatCurrency } from "../../../utils/formatCurrency";
import usePermission from "../../../hooks/usePermission";

export default function Sales() {
  usePermission("127"); //Visualizar Relatorio de Vendas
  const { nomenclatures, permissions } = useAppContext();
  const nomenclature = JSON.parse(nomenclatures);
  const navigate = useNavigate();

  const [now, setNow] = useState("");
  const [logo, setLogo] = useState();
  const [user, setUser] = useState("");
  const [table, setTable] = useState();
  const [filters, setFilters] = useState();
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [completeReport, setCompleteReport] = useState(false);

  const items = [
    {
      template: () => (
        <Link to={"/reports/sales"} className="p-breadcrumb-link">
          Relatório de Vendas
        </Link>
      ),
    },
  ];
  const home = {
    template: () => (
      <Link to={"#"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  const exportToExcel = (sheetname) => {
    const data = table.data.map((item) => {
      //      console.log(item)
      return {
        Código: item.id,
        [nomenclature[0].value]: item.block,
        [nomenclature[1].value]: item.land,
        Empreendimento: item.enterprise,
        "Valor Venda": formatCurrency(item.sale_value),
        ...(table.sum.signal_total > 0 && {
          "Valor Sinal": formatCurrency(item.signal_value),
        }),
        ...(table.sum.single_total > 0 && {
          "Valor Parcela Unica": formatCurrency(item.single_value),
        }),
        ...(table.sum.entry_total > 0 && {
          "Valor de Entrada": formatCurrency(item.entry_value),
        }),
        ...(table.sum.entry_total > 0 && {
          "Qtd de Entrada": item.number_entry_installments,
        }),
        ...(table.sum.intermediate_total > 0 && {
          "Valor de Intermediaria": formatCurrency(item.intermediate_value),
        }),
        ...(table.sum.intermediate_total > 0 && {
          "Qtd de Intermediaria": item.number_intermediate_installments,
        }),
        ...(table.sum.construction_total > 0 && {
          "Valor Parcela de Obra": formatCurrency(item.construction_value),
        }),
        ...(table.sum.construction_total > 0 && {
          "Qtd Parcela de Obra": item.number_construction_installments,
        }),
        ...(table.sum.financing_total > 0 && {
          "Valor Financiamento": formatCurrency(item.financing_value),
        }),
        ...(table.sum.financing_total > 0 && {
          "Qtd Parcelas Financiamento": item.number_financing_installments,
        }),
        Taxa: `${item.financing_rate}%`,
        "Data 1° Parcela Financiamento": formatDate(
          item.first_financing_installment
        ),
        "Data Última Parcela Financiamento": formatDate(
          item.last_financing_installment
        ),
        "Nome Cliente": item.client.name,
        CPF: item.client.doc,
        CEP: item.client.address?.cep,
        Endereço: item.client.address?.address,
        Número: item.client.address?.num,
        Bairro: item.client.address?.neighborhood,
        Cidade: item.client.address?.city,
        Estado: item.client.address?.state,
        Imobiliária: item.real_estate,
        Vendedor: item.seller,
      };
    });

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(data);

    XLSX.utils.book_append_sheet(wb, ws, sheetname);

    XLSX.writeFile(wb, `relatório_vendas.xlsx`);
  };

   const handleExportPDF = () => {
      const element = document.getElementById("sales-report");
      if (!element) return;
  
      const options = {
        margin: 10,
        filename: `resumo-vendas - ${now}.pdf`,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2,  },
        jsPDF: { unit: "mm", format: "a3", orientation: "landscape",  },
        pagebreak: { mode: ['css', 'legacy'], avoid: 'tr' }

      };
  
      html2pdf()
        .from(element)
        .set(options)
        .save()
        .then(() => {
          element.classList.remove("force-light");
        })
        .catch(() => {
          element.classList.remove("force-light");
        });
    };

  

  

  return (
    <div className="row d-flex justify-content-between mb-3">
      <div>
        <BreadCrumb
          model={items}
          home={home}
          style={{
            background: "transparent",
            border: "none",
            fontSize: "16px",
          }}
        />
      </div>
      <Panel title="Filtre para obter informações das vendas">
        <FiltersSales
          setNow={setNow}
          setLogo={setLogo}
          setUser={setUser}
          loading={loading}
          setTable={setTable}
          setLoading={setLoading}
          setFilters={setFilters}
          setVisible={setVisible}
          completeReport={completeReport}
          setCompleteReport={setCompleteReport}
        />
      </Panel>

      {loading && <Skeleton width="100%" height="500px" className="mt-4" />}

      {visible && !loading && (
        <Panel mainCss="mt-4">
          <>
            {/* <hr className="my-4" /> */}
            <div className="px-2 pb-3">
              <div className="d-flex justify-content-end">
                <Button
                  onClick={() => exportToExcel("Relatório de Vendas")}
                  icon={<Excel />}
                  iconPos="center"
                  className="p-button-success me-2 mb-3"
                  tooltip="Exportar para Excel"
                  tooltipOptions={{ position: "top" }}
                  rounded
                />
                <Button
                  onClick={handleExportPDF}
                  icon="fa fa-file-pdf"
                  className="p-button-secondary me-2 mb-3"
                  tooltip="Exportar para PDF"
                  tooltipOptions={{ position: "top" }}
                  rounded
                />
                
              </div>
              <div id="sales-report">
              <ModelReport
                date={now}
                madeBy={table.user.name}
                title="RELATÓRIO DE VENDAS"
                logo={table.enterprise.img}
                legend={
                  <>
                    <p className="mb-0">Legenda:</p>
                    <div className="row justify-content-center">
                      <div className="col-md-6 d-flex">
                        <h6 className="mt-1" style={{ marginLeft: "12px" }}>
                          <span
                            className={"badge bg-warning"}
                            style={{
                              fontSize: "7px",
                            }}
                          >
                            PA
                          </span>
                        </h6>
                        <h6 className="mt-1" style={{ marginLeft: "12px" }}>
                          Proposta em Análise
                        </h6>
                      </div>
                      <div className="col-md-6 d-flex">
                        <h6 className="mt-1" style={{ marginLeft: "12px" }}>
                          <span
                            className={"badge bg-danger"}
                            style={{
                              fontSize: "7px",
                            }}
                          >
                            PR
                          </span>
                        </h6>
                        <h6 className="mt-1" style={{ marginLeft: "12px" }}>
                          Proposta Recusada
                        </h6>
                      </div>
                      <div className="col-md-6 d-flex">
                        <h6 className="mt-1" style={{ marginLeft: "12px" }}>
                          <span
                            className={"badge bg-success"}
                            style={{
                              fontSize: "7px",
                            }}
                          >
                            PAP
                          </span>
                        </h6>
                        <h6 className="mt-1" style={{ marginLeft: "12px" }}>
                          Proposta Aprovada
                        </h6>
                      </div>
                      <div className="col-md-6 d-flex">
                        <h6 className="mt-1" style={{ marginLeft: "12px" }}>
                          <span
                            className={"badge bg-info"}
                            style={{
                              fontSize: "7px",
                            }}
                          >
                            CA
                          </span>
                        </h6>
                        <h6 className="mt-1" style={{ marginLeft: "12px" }}>
                          Contrato Ativo
                        </h6>
                      </div>
                      <div className="col-md-6 d-flex">
                        <h6 className="mt-1" style={{ marginLeft: "12px" }}>
                          <span
                            className={"badge bg-success"}
                            style={{
                              fontSize: "7px",
                            }}
                          >
                            CC
                          </span>
                        </h6>
                        <h6 className="mt-1" style={{ marginLeft: "12px" }}>
                          Contrato Concluído
                        </h6>
                      </div>
                      <div className="col-md-6 d-flex">
                        <h6 className="mt-1" style={{ marginLeft: "12px" }}>
                          <span
                            className={"badge bg-danger"}
                            style={{
                              fontSize: "7px",
                            }}
                          >
                            CD
                          </span>
                        </h6>
                        <h6 className="mt-1" style={{ marginLeft: "12px" }}>
                          Contrato Distratado
                        </h6>
                      </div>
                      <div className="col-md-12 d-flex">
                        <h6 className="mt-1" style={{ marginLeft: "12px" }}>
                          <span
                            className={"badge bg-dark"}
                            style={{
                              fontSize: "7px",
                            }}
                          >
                            CCE
                          </span>
                        </h6>
                        <h6 className="mt-1" style={{ marginLeft: "12px" }}>
                          Contrato Cobrança Extrajudicial
                        </h6>
                      </div>
                    </div>
                  </>
                }
                filters={filters}
              >
                <TableSalesReport table={table && table} />
              </ModelReport>
              </div>
            </div>
          </>
        </Panel>
      )}
    </div>
  );
}
